// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__MLEsignaturePolChangeComponent__fieldContentLeft{text-align:left}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/ml-capability-policychange-common-react/components/MLEsignaturePolChangeComponent/MLEsignaturePolChangeComponent.module.scss"],"names":[],"mappings":"AAAA,uDACE,eAAA","sourcesContent":[".fieldContentLeft {\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldContentLeft": "app__MLEsignaturePolChangeComponent__fieldContentLeft"
};
export default ___CSS_LOADER_EXPORT___;
